export default class SnackbarController {
  static $inject = ['$transclude'];

  enabledAction:boolean;

  constructor($transclude:any) {
    this.enabledAction = $transclude.isSlotFilled('action');
  }
}




/** WEBPACK FOOTER **
 ** ./app/snackbar/snackbar.controller.ts
 **/